module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_133882-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_133882-00001"
    }
  }, [_c('p', {
    staticClass: "title-other"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "chap-img5.png"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "title-other"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "chap-img3.png"
    }
  })])])]), _c('div', {
    staticClass: "block list-toc",
    attrs: {
      "id": "rw-block-list-toc_133882-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847678164_chapter_01#rw-title-block_133883-00001"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847678164_chapter_02#rw-media-figure_133884-00001"
    }
  }, [_vm._v("A Grimaldi Family Tree")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847678164_chapter_03#rw-title-block_133885-00001"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847678164_introduction#rw-title-block_133886-00001"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-00001"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781847678164_part_01"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("PART ONE")]), _vm._v(" 1778–1800")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-00002"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847678164_chapter_04#rw-title-block_133888-00001"
    }
  }, [_vm._v("1. The Wonders of Derbyshire")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847678164_chapter_05#rw-title-block_133889-00001"
    }
  }, [_vm._v("2. The Wizard of the Silver Rocks")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_06#rw-title-block_133890-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Harlequin’s Frolics")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_07#rw-title-block_133891-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Flying World")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-00003"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/9781847678164_part_02#rw-title-block_133892-00001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("PART TWO")]), _vm._v(" 1800–10")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-00004"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_08#rw-title-block_133893-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Magic of Mona")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_09#rw-title-block_133894-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Spirit of the Waters")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_10#rw-title-block_133895-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Mother Goose")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_11#rw-title-block_133896-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Forty Virgins")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_viii"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-00005"
    }
  }, [_c('p')])]), _c('p', {
    staticClass: "fp",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/9781847678164_part_03#rw-title-block_133897-00001",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("PART THREE")]), _vm._v(" 1811–37")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-00006"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_12#rw-title-block_133898-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Harlequin in His Element")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_13#rw-title-block_133899-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Orphan of Peru")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_14#rw-title-block_133900-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Poor Robin")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_15#rw-title-block_133901-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Libertine Destroyed")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847678164_epilogue#rw-title-block_133902-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-00007"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847678164_chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: Harlequin and Mother Goose; or, The Golden Egg!")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-00008"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847678164_acknowledgements#rw-title-block_133904-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-00009"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847678164_notes#rw-title-block_133905-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-000010"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847678164_bibliography#rw-title-block_133906-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_133882-000011"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847678164_index#rw-title-block_133907-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b6da40c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847678164_tableofcontents.vue
// module id = 66
// module chunks = 0